var React = require("react");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var TDAddButton = createReactClass({
	propTypes: {
		show: PropTypes.bool,
		value: PropTypes.string,
		onChange: PropTypes.func.isRequired
	},
	change: function() {
		this.props.onChange({
			action: "add_row"
		});
	},
	render: function() {
		var button = null;
		if(this.props.show) {
			button = (
				<button type="button"
					className="btn btn-primary btn-sm btn-icon-only"
					onClick={this.change}
					disabled={this.props.disabled}
				>
						<span className="fa fa-plus no-text"
							aria-hidden="true"/>
				</button>
			)
		}
		return (
			<td className="text-center actions">
				<div className="form-group">
					{button}
				</div>
			</td>
		)
	}
});

module.exports = TDAddButton;
